import { createFileRoute } from "@tanstack/react-router";
import { AdminOrgsPage } from "@/features/admin/orgs";

export const Route = createFileRoute("/admin/orgs")({
  head: () => ({ meta: [{ title: "Organizations · Admin · Malfak" }] }),
  component: AdminOrgsPage,
});
